<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-body>
        <div class="flex-centered col-xl-4 col-lg-6 col-md-8 col-sm-12">
          <h2 class="title">404 página não encontrada</h2>          
          <button nbButton fullWidth (click)="goToHome()" type="button" class="home-button">
            Voltar para home.
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
